// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='TimelineDatapointDialog'] > header button {\n      display: none;\n    }\n  [name='TimelineDatapointDialog'] input[type='text'] {\n    font-size: 14px;\n    height: inherit;\n  }\n", ""]);
// Exports
module.exports = exports;
